var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurveFlow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 638,
    height: 420,
    viewBox: "0 0 638 420",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M638 2.10299L577.289 22.8531C457.358 70.0702 366.61 151.165 283.319 247.081C254.348 280.324 227.507 315.472 198.11 348.291C173.4 376.028 145.494 406.518 110.132 419.858C107.15 419.434 98.203 403.766 96.4988 400.59C67.7409 341.516 90.7472 226.755 36.4267 186.101C25.7756 178.055 12.9943 173.609 0 171.068C21.5152 137.19 54.9596 120.04 92.8775 142.06C125.896 161.328 147.411 205.581 152.097 242.423L153.589 277.36C191.293 220.826 237.732 169.798 290.136 126.392C385.569 47.4145 510.613 -12.7185 638 2.31473V2.10299Z",
    fill: "url(#paint0_linear_1433_3924)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1433_3924",
    x1: 0,
    y1: 209.816,
    x2: 638,
    y2: 209.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01C9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#02BEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#0A90FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#106EFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#135AFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1553FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurveFlow);
export default __webpack_public_path__ + "static/media/curve-flow.36b2276a7f17e4e2ac71c83309fad978.svg";
export { ForwardRef as ReactComponent };